import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-afip',
  templateUrl: './dialog-afip.component.html',
  styleUrls: ['./dialog-afip.component.scss']
})
export class DialogAfipComponent {
  header: string;

  message: string;

  constructor(private dialogRef: MatDialogRef<DialogAfipComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {
    this.header = data.title;
    this.message = data.error;
  }

  close() {
    this.dialogRef.close();
  }
}
